/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-29 16:11:16
 * @FilePath: /wemeet-admin-new/src/api/login.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 登录方法
export function login(username, password, captchaCode, requestId) {
  const data = {
    username,
    password,
    captchaCode,
    requestId,
  }
  return request({
    url: '/iam/login',
    method: 'post',
    data: data,
  })
}

// 获取用户详细信息
export function getUserInfo() {
  return request({
    url: '/iam/getUserInfo?sysCode=mehz',
    method: 'get',
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post',
  })
}

// 获取验证码
export function getCaptchaImage() {
  return request({
    url: '/iam/captchaImage',
    method: 'get',
  })
}

export function getPhoneVerifyCode(params) {
  return request({
    url: '/iam/myself/user/getPhoneVerifyCode',
    method: 'get',
    params,
  })
}
